import { Employee, Society } from 'types';
import {
  getEmployeeSalaryAmount,
  getEmployeeTeam,
  isEmployeeLinkedToBeneficiary,
} from 'utils/employees';

type EmployeeDataProps = {
  employees: Employee[];
  society: Society;
  beneficiariesExternalId: number[];
  t: any;
};

export const parseEmployeesData = ({
  employees,
  society,
  beneficiariesExternalId,
  t,
}: EmployeeDataProps) =>
  employees?.map((employee) => ({
    employee,
    externalId: employee.externalId,
    externalIdSearch: String(employee.externalId ?? ''),
    name: [employee.firstName, employee.lastName].join(' '),
    email: employee.email,
    location: [
      employee.address?.city,
      employee.address?.country?.toUpperCase(),
    ].join(', '),
    status: {
      text: !employee.terminationDate ? t('Active') : t('Inactive'),
      color: !employee.terminationDate ? 'success' : 'danger',
    },
    isActive: !employee.terminationDate,
    currency: 'EUR',
    cif: employee.cif,
    cifType: employee.cifType,
    salary: getEmployeeSalaryAmount(employee),
    hasIncentive: {
      text: isEmployeeLinkedToBeneficiary(employee, beneficiariesExternalId)
        ? t('Yes')
        : t('Not'),
      color: isEmployeeLinkedToBeneficiary(employee, beneficiariesExternalId)
        ? 'success'
        : 'danger',
    },
    hasIncentivePlan: isEmployeeLinkedToBeneficiary(
      employee,
      beneficiariesExternalId
    ),
    department: getEmployeeTeam(employee),
    societyId: society._id,
  }));
